import { QueryList, TemplateRef } from '@angular/core';
import { TabComponent } from '../components/atoms/tab/tab.component';

/** Interface of Tab header config */
export interface TabHeadersConfig {
  followFocus: boolean;
  isNavigation?: boolean;
}

/**  Interface of Tab Header content */
export interface TabHeadersContent {
  ariaLabel: string;
  ariaLabelledby: string;
  tabs: QueryList<TabComponent>;
}

export interface TabHeaderData {
  config: TabHeadersConfig;
  content: TabHeadersContent;
}

export interface TabHeader {
  template?: boolean;
  headerTemplate?: TemplateRef<HTMLElement>;
}

/** Interface of each tab */
export interface TabContent extends TabHeader {
  heading: string;
  context?: string;
  active?: boolean;
  index?: number;
  tabIndex?: number | null;
  isDisabled?: boolean;
}
